import { createFilter } from '@spotify/confidence-core-react';
import {
  EntityFilterEditor,
  EntityFilterViewer,
} from '@spotify/plugin-confidence-metrics-react';

export const ENTITY_FILTER = createFilter<string[]>({
  id: 'entities',
  label: 'Entity',
  hotkey: 'e',
  query: (value: string[]) =>
    value.map(v => `module_data.metrics.entity:"${v}"`).join(' OR '),
  viewer: EntityFilterViewer,
  editor: EntityFilterEditor,
});
